/* DDT v17.53: free Busch bur pack with $500+ Helmut Zepf.
   Adds the chosen pack to the cart and refreshes the theme's cart drawer / cart page.
   Markup lives in snippets/zepf-free-bur-pack.liquid. */
(function () {
  if (window.zfbInit) return;
  window.zfbInit = true;

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-zfb-add]');
    if (!btn || btn.disabled) return;
    evt.preventDefault();

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';

    var base = (window.theme && window.theme.routes && window.theme.routes.cartAdd) || '/cart/add';
    fetch(base + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(btn.dataset.zfbAdd), quantity: 1 }] })
    }).then(function (response) {
      if (!response.ok) throw new Error('zfb add failed: ' + response.status);
      var drawer = document.getElementById('cart-drawer');
      var cartItems = document.querySelector('cart-items');
      if (drawer && typeof drawer.refresh === 'function') {
        drawer.refresh();
      } else if (cartItems && typeof cartItems.refresh === 'function') {
        cartItems.refresh();
      } else {
        window.location.reload();
      }
    }).catch(function (err) {
      btn.disabled = false;
      btn.textContent = label;
      console.log(err); // eslint-disable-line
    });
  });
})();
